"use client";
import type { HostFamilyActionSnapshot } from "@-/access";
import type { Prisma } from "@-/prisma";
import type { TransferHistoryApplication } from "@/components/applications/ApplicationTransferHistory";
import type { IncomingProfileReferral } from "@/utils/host-family-referrals.server";
import { createContext } from "react";
import type { hostFamilyLayoutInclude } from "./include";

export type HostFamilyLayoutContext = {
  acquisitionSourceReadOnly: boolean;
  canIssueHostFamilyDocument: boolean;
  hostFamily: Prisma.HostFamilyProfileGetPayload<{
    include: typeof hostFamilyLayoutInclude;
  }>;
  hostFamilyActions: HostFamilyActionSnapshot;
  incomingReferral: IncomingProfileReferral | null;
  profileApplications: readonly TransferHistoryApplication[];
};

const LayoutContext = createContext<HostFamilyLayoutContext>(null!);

export default LayoutContext;
